import React, { useEffect, useRef, useState } from "react";
import {
  GstrOneAutoFilledTable,
  GstrOneTable,
} from "../../../../components/Gst";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import Select from "react-select";
import {
  CommonHeader,
  ConfirmationModal,
  ErrorSuccessModal,
  Loader,
  TableHeader,
} from "../../../../components/commons";

import RenderHeaderCard from "../../../../components/commons/ContentArea/RenderHeaderCard";
import "../../styles.scss";
import { GetAllBussinessAddressesListPayloadType } from "../../../../commonTypes/clientSettingsTypes";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import { getAllBusinessAddressAction } from "../../../../redux/clientSettings";
import { useParams } from "react-router-dom";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import {
  finacialYear,
  finacialYearMonth,
} from "../../../../components/commons/Gst";
import { resetSession } from "../../../../redux/auth";
import {
  ARNNumberPayloadType,
  ApproveGstPayloadType,
  GetGstNumberPayload,
  GstCommentPayloadType,
  GstGetAllCommentPayloadType,
  GstNumberType,
  GstrOneDataType,
  GstrOneFilingStatusDataType,
  GstrOnePayload,
  GstrOneSatusType,
  GstrOnehsnWiseCountPayload,
  getGstrOnehsnWiseCountType,
} from "../../../../commonTypes/gstTypes";
import {
  approveGstAction,
  getGstNumberList,
  getGstrOneInvoiceListAction,
  getGstrOneListAction,
  getGstrOnehsnWiseCountAction,
  gstGetAllCommentAction,
  gstOneFilingStatus,
  gstPostCommentAction,
  postARNNumberAction,
  resetGstCommentsSuccess,
  resetGstFilingError,
  resetGstFilingSuccess,
  resetGstMessage,
  resetGstModuleError,
  resetGstModuleSuccess,
  resetGstNumberList,
  resetGstOneFilingStatus,
  resetGstOneFilingStatusError,
  resetGstOneFilingStatusMessage,
  resetGstOneFilingStatusStatusCode,
  resetGstOneFilingStatusSuccess,
  resetGstrInvoiceList,
  resetGstrOneData,
  resetGstrOnehsnWiseList,
} from "../../../../redux/gstModule";
import { resetFetching } from "../../../../redux/jobs";
import { gstrDataTemplate } from "../../../../constant/tableHeadersConstants/gst";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import { components } from "react-select";
import Approve from "../../../../components/commons/ApprovalModule/Approve";
import {
  changeToDecimel,
  checkSameUserId,
  getMonthNumber,
} from "../../../../utils/commonFunctions";
import toast, { Toaster } from "react-hot-toast";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
import CommentModal from "../../../../components/commons/CommentModal/CommentModal";
import CommfirmationWithActionModal from "../../../../components/commons/CommfirmationWithActionModal/CommfirmationWithActionModal";
import { HSN_SUMMARY_HEADERS } from "../../../../constant/tableHeadersConstants/gst/gstr3bConstant";
import { WarningIcon } from "../../../../assets/images";
type AppProps = {
  token: string | null;
  history: any;
  success: number | null;
  error: string | null | undefined;
  statusCode: number | null;
  fetching: boolean;
  message: string | null;
  branch: any | null;
  gstrOneData: GstrOneDataType | any;
  gstrOneInvoiceList: any;
  getGstrOnehsnWiseList: getGstrOnehsnWiseCountType[] | [];
  gstNumberList: GstNumberType[] | [];
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchGetGstrOneAction: (data: GstrOnePayload) => void;
  dispatchGetGstrOneInvoiceListAction: (data: GstrOnePayload) => void;
  dispatchResetSession: () => void;
  dispatchResetGstrOne: () => void;
  dispatchResetFetching: () => void;
  dispatchResetMessage: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetGstModuleError: () => void;
  dispatchResetGstInvoiceListAction: () => void;
  dispatchGetGstrOnehsnWiseCountAction: (
    data: GstrOnehsnWiseCountPayload
  ) => void;
  dispatchResetGetGstrOnehsnWiseCount: () => void;
  dispatchResetGstFillingError: () => void;
  dispatchResetGstFillingSuccess: () => void;
  dispatchGetGstNumber: (data: GetGstNumberPayload) => void;
  dispatchResetGetGstNumber: () => void;
  dispatchApproveGst: (data: ApproveGstPayloadType) => void;
  loginData: LoginResponseType;
  gstCommentData: any;
  dispatchPostGstCommentsAction: (data: GstCommentPayloadType) => void;
  gstCommentSuccess: null | number;
  dispatchResetCommentsSuccess: () => void;
  dispatchGetAllGstCommentsAction: (data: GstGetAllCommentPayloadType) => void;
  dispatchGstOneFilingStatus: (data: GstrOneSatusType) => void;
  gstOneFilingStatusSuccess: number | null;
  gstOneFilingStatusError: string | null | undefined;
  gstOneFilingStatusStatusCode: number | null;
  gstOneFilingStatusMessage: string | null;
  dispatchResetGstOneFilingStatus: () => void;
  dispatchResetGstOneFilingStatusSuccess: () => void;
  dispatchResetGstOneFilingStatusError: () => void;
  dispatchResetGstOneFilingStatusStatusCode: () => void;
  dispatchResetGstOneFilingStatusMessage: () => void;
  gstOneFilingStatus: GstrOneFilingStatusDataType | any;
  dispatchPostARNNumberAction: (data: ARNNumberPayloadType) => void;
};

const GstrOne = ({
  token,
  history,
  branch,
  fetching,
  success,
  error,
  statusCode,
  message,
  gstrOneData,
  gstrOneInvoiceList,
  dispatchResetSuccess,
  dispatchResetFetching,
  dispatchResetMessage,
  dispatchGetGstrOneAction,
  dispatchResetSession,
  dispatchResetGstrOne,
  dispatchGetAllBusinessAddressAction,
  dispatchGetGstrOneInvoiceListAction,
  dispatchResetGstModuleError,
  dispatchResetGstInvoiceListAction,
  dispatchGetGstrOnehsnWiseCountAction,
  dispatchResetGetGstrOnehsnWiseCount,
  getGstrOnehsnWiseList,
  dispatchResetGstFillingError,
  dispatchResetGstFillingSuccess,
  dispatchGetGstNumber,
  dispatchResetGetGstNumber,
  gstNumberList,
  dispatchApproveGst,
  loginData,
  gstCommentData,
  dispatchPostGstCommentsAction,
  gstCommentSuccess,
  dispatchResetCommentsSuccess,
  dispatchGetAllGstCommentsAction,
  dispatchGstOneFilingStatus,
  gstOneFilingStatusSuccess,
  gstOneFilingStatusError,
  gstOneFilingStatusStatusCode,
  gstOneFilingStatusMessage,
  dispatchResetGstOneFilingStatus,
  dispatchResetGstOneFilingStatusSuccess,
  dispatchResetGstOneFilingStatusError,
  dispatchResetGstOneFilingStatusStatusCode,
  dispatchResetGstOneFilingStatusMessage,
  gstOneFilingStatus,
  dispatchPostARNNumberAction,
}: AppProps) => {
  const [branchList, setBranchList] = useState<any>([]);
  const [gstNoList, setGstNoList] = useState<any>([]);
  const [financialYear, setFinancialYear] = useState<OptionsType>({
    value: "",
    label: "Select Fy",
  });
  const [month, setMonth] = useState<OptionsType>({ value: "", label: "" });
  const [gstNo, setGstNo] = useState<OptionsType | any>({
    value: "",
    label: "Select GST No.",
  });
  const [branchSelected, setBranchSelected] = useState<OptionsType>({
    value: "",
    label: "Select Branch",
  });
  const [gstrOneInvoiceData, setGstrOneInvoiceData] = useState<any>({});
  const { id } = useParams<any>();
  const finacialYearOptions = finacialYear(2017);
  const financialStartYear = financialYear?.label.split("-")[0]?.slice(2, 4);
  const financialEndYear = financialYear?.label.split("-")[1];
  const getMonthsOptions: TableHeadersType[] = finacialYearMonth(
    financialStartYear,
    "Apr",
    +financialEndYear
  )?.map((e: TableHeadersType) => {
    return {
      label: e.label,
      value: e.value,
    };
  });
  const [gstfiledData, setGstfiledData] = useState<any>({});
  const [invoiceSourceKey, setInvoiceSourceKey] = useState<string>("");
  const [nestedSourceKey, setNestedSourceKey] = useState("");
  const [gstrInvoiceType, setGstrInvoiceType] = useState<string | null>("");
  const [gstr1Data, setGstr1Data] = useState<GstrOneDataType | {}>([]);
  const [showhsnCount, setShowhsnCount] = useState(false);
  const [approved, setApproved] = useState<boolean>(false);
  const [showGstCommentsModal, setShowGstCommentsModal] =
    useState<boolean>(false);
  const [commentData, setCommentData] = useState<any>(null); //comment model data
  const [fillGstToggle, setFillGstToggle] = useState(false);
  const [isNil, setIsNil] = useState(false);
  const [isGstFillingPresent, setIsGstFillingPresent] = useMenuCheck();
  const [isApprovalPresent, setIsApprovalPresent] = useMenuCheck();
  const [isCommentPresent, setIsCommentPresent] = useMenuCheck();
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : id
      ? id
      : null;
  const company_name: string = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : localStorage.getItem("company_name");

  useEffect(() => {
    resetData();
    dispatchResetFetching();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetGstrOne();
    dispatchResetGstModuleError();
    dispatchResetGstInvoiceListAction();
    dispatchResetGetGstrOnehsnWiseCount();
    dispatchResetGstFillingError();
    dispatchResetGstFillingSuccess();
    dispatchResetGstOneFilingStatus();
    dispatchResetGstOneFilingStatusSuccess();
    dispatchResetGstOneFilingStatusError();
    dispatchResetGstOneFilingStatusStatusCode();
    dispatchResetGstOneFilingStatusMessage();
    dispatchResetGetGstNumber();
    setIsGstFillingPresent("GST One Filling", "menu");
    setIsApprovalPresent("GSTR-One Approval", "menu");
    setIsCommentPresent("GSTR-One Comment", "menu");
    const getFinancialYear = finacialYear(2017);
    if (getFinancialYear?.length > 0) {
      setFinancialYear(getFinancialYear[getFinancialYear?.length - 1]);
    }

    if (token) {
      let data = {
        token,
        client_code,
      };

      dispatchGetAllBusinessAddressAction(data);
      dispatchGetGstNumber(data);
    }
  }, []);

  useEffect(() => {
    setGstr1Data(gstrDataTemplate(gstrOneData));
  }, [gstrOneData]);

  useEffect(() => {
    if (gstrOneData?.gstr1_filing_details?.acknowledgement_number) {
      setGstfiledData({
        ackNumber: gstrOneData?.gstr1_filing_details?.acknowledgement_number,
        gstr1FilingDate: gstrOneData?.gstr1_filing_details?.gstr1_filing_date,
        gstrFilingBy: gstrOneData?.gstr1_filing_details?.gstr1_filing_by,
      });
    } else {
      setGstfiledData({});
    }
  }, [gstrOneData]);

  useEffect(() => {
    if (showGstCommentsModal) {
      let monthData = month?.value?.split("-")?.[0];
      if (financialYear) {
        const finalData = {
          client_code: client_code,
          gstin: gstNo?.value,
          financial_year: financialYear?.value,
          month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
            getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
          }`,
          gst_form_type: "GSTR1",
          token,
        };
        dispatchGetAllGstCommentsAction(finalData);
      }
    }
  }, [showGstCommentsModal]);

  const handleShowConfirmationModal = () => {
    setFillGstToggle(!fillGstToggle);
  };

  useEffect(() => {
    if (!fillGstToggle) {
      setIsNil(false);
    }
  }, [fillGstToggle]);

  useEffect(() => {
    if (success === 1 && message === "GSTR1 Form approved successfully.") {
      dispatchResetSuccess();
      dispatchResetMessage();
      toast.success("GSTR1 Form approved successfully.", {
        duration: 2000,
      });
      if (token) {
        let data = {
          token,
          client_code,
          branch_id: branchSelected.value,
          finacial_year: financialYear.value,
          month: month.value,
          gst_number: gstNo?.value,
        };
        branchSelected?.value
          ? delete data?.gst_number
          : delete data?.branch_id;
        dispatchGetGstrOneAction(data);
        setGstrOneInvoiceData({});
      }
    }
  }, [message]);

  useEffect(() => {
    if (
      success === 1 &&
      message === "Acknowledgement Number added successfull."
    ) {
      dispatchResetSuccess();
      dispatchResetMessage();
      toast.success("Acknowledgement Number added successfully.", {
        duration: 2000,
      });
      dispatchResetGstInvoiceListAction();
      dispatchResetGetGstrOnehsnWiseCount();
      dispatchResetGstrOne();
      setGstrInvoiceType("");
      if (token) {
        let data = {
          token,
          client_code,
          branch_id: branchSelected.value,
          finacial_year: financialYear.value,
          month: month.value,
          gst_number: gstNo?.value,
        };
        branchSelected?.value
          ? delete data?.gst_number
          : delete data?.branch_id;

        dispatchGetGstrOneAction(data);
      }
    }
  }, [message]);

  useEffect(() => {
    if (financialYear) {
      setMonth({
        value: `Apr-${financialStartYear}`,
        label: `Apr-${financialStartYear}`,
      });
    }
  }, [financialYear]);

  useEffect(() => {
    if (
      loginData?.user_id ||
      gstrOneData?.approval_details?.approval_details?.length > 0
    ) {
      let user_id;

      if (loginData?.user_id) {
        user_id = checkSameUserId(
          loginData?.user_id,
          gstrOneData?.approval_details?.approval_details
        );
      }
      let totelArrpovedData =
        gstrOneData?.approval_details?.approval_details?.length === 3;
      setApproved(user_id || totelArrpovedData);
    }
  }, [loginData?.user_id, gstrOneData?.approval_details]);

  useEffect(() => {
    if (!!gstrInvoiceType) {
      let finalData = {
        token,
        client_code,
        branch_id: branchSelected.value,
        finacial_year: financialYear.value,
        month: month.value,
        gstr1_type: gstrInvoiceType,
        gst_number: gstNo?.value,
      };
      branchSelected?.value
        ? delete finalData?.gst_number
        : delete finalData?.branch_id;
      dispatchGetGstrOneInvoiceListAction(finalData);
    }
  }, [gstrInvoiceType]);

  useEffect(() => {
    let newData = branch?.map((item: any) => {
      return {
        label: item?.trade_name,
        value: item?.ledger_id,
        gstIn: item?.gst_number,
        legalName: item?.legal_name,
        panNumber: item?.pan_number,
        authorizedSignatoryEmail: item?.authorized_signatory_email,
        authorizedSignatoryName: item?.authorized_signatory_name,
        authorizedSignatoryPanNumber: item?.authorized_signatory_pan_number,
        authorizedSignatoryPhoneNumber: item?.authorized_signatory_phone_number,
        authorizedSignatoryPanDeatils: { status: "VALID" },
      };
    });
    setBranchList([...newData]);
  }, [branch]);

  const handleToggleGstCommentsModal = () => {
    setShowGstCommentsModal(!showGstCommentsModal);
  };

  useEffect(() => {
    let newData = gstNumberList?.map((item: any) => {
      return {
        label: `${item?.gst_number ? item?.gst_number : ""} % ${
          item?.trade_name ? item?.trade_name : ""
        }`,
        value: item?.gst_number,
        gstIn: item?.gst_number,
        legalName: item?.legal_name,
        tradeName: item?.trade_name,
        panNumber: item?.pan_number,
        authorizedSignatoryEmail: item?.authorized_signatory_email,
        authorizedSignatoryName: item?.authorized_signatory_name,
        authorizedSignatoryPanNumber: item?.authorized_signatory_pan_number,
        authorizedSignatoryPhoneNumber: item?.authorized_signatory_phone_number,
        authorizedSignatoryPanDeatils: item?.authorized_signatory_pan_details,
      };
    });
    if (newData?.length) {
      setGstNoList([...newData]);
    } else {
      setGstNoList([]);
    }
  }, [gstNumberList]);

  useEffect(() => {
    if (
      financialYear?.value?.length > 0 &&
      !!month?.value &&
      (branchSelected?.value || gstNo?.value)
    ) {
      dispatchResetGstInvoiceListAction();
      dispatchResetGetGstrOnehsnWiseCount();
      dispatchResetGstrOne();
      setGstrInvoiceType("");
      let monthData = month?.value?.split("-")?.[0];
      if (token) {
        let data = {
          token,
          client_code,
          branch_id: branchSelected.value,
          finacial_year: financialYear.value,
          month: month.value,
          gst_number: gstNo?.value,
        };
        branchSelected?.value
          ? delete data?.gst_number
          : delete data?.branch_id;
        let yearData = 20 + month?.value?.split("-")?.[1];
        let finalData = {
          token,
          client_code,
          gst_number: gstNo?.value,
          year: yearData,
          month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
            getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
          }`,
        };
        dispatchGetGstrOneAction(data);
        dispatchGstOneFilingStatus(finalData);
        setGstrOneInvoiceData({});
      }
    }
  }, [branchSelected, month, financialYear, gstNo]);

  useEffect(() => {
    if (gstrOneInvoiceList) {
      setGstrOneInvoiceData({ ...gstrOneInvoiceData, ...gstrOneInvoiceList });
    }
  }, [gstrOneInvoiceList]);

  useEffect(() => {
    if (showhsnCount && token) {
      let data = {
        token,
        client_code,
        branch_id: branchSelected.value,
        month: month.value,
        gst_number: gstNo?.value,
      };
      branchSelected?.value ? delete data?.gst_number : delete data?.branch_id;
      dispatchGetGstrOnehsnWiseCountAction(data);
    }
  }, [showhsnCount]);

  const handleChangeInput = (data: any, name: string) => {
    if (name === "branch") {
      setBranchSelected({ ...data });
      setGstNo({ value: "", label: "Select GST No." });
    } else if (name === "fy") {
      setFinancialYear({ ...data });
    } else if (name === "month") {
      setMonth({ ...data });
    } else if (name === "gstno") {
      setGstNo({ ...data, label: data?.label?.split("%")[0] });
      setBranchSelected({ value: "", label: "Select Branch" });
    }
  };

  const getGstrType = (type: string) => {
    switch (type) {
      case "4aTaxable":
        return "4A";
      case "4bTaxable":
        return "4B";
      case "5ATaxable":
        return "5A";
      case "6AExports":
        return "6A";
      case "6BSupplies":
        return "6B";
      case "7Taxable":
        return "7";
      case "8Nil":
        return "8";
      case "9BCredit/Debit":
        return "9B";
      case "12HSN":
        return "12";
      case "13Documents":
        return "13";
      default:
        return null;
    }
  };

  const handleGstrOneInvoiceList = (gstr1Type: any, nestedId: any) => {
    let gstrType = getGstrType(gstr1Type);
    setGstrInvoiceType(gstrType);
    setInvoiceSourceKey(gstr1Type);
    setNestedSourceKey(nestedId);

    if (gstrInvoiceType == gstrType) {
      setGstrOneInvoiceData({ ...gstrOneInvoiceData, ...gstrOneInvoiceList });
    }
  };

  const handleApproval = () => {
    let monthData = month?.value?.split("-")?.[0];
    if (financialYear) {
      const finalData = {
        client_code: client_code,
        gstin: gstNo?.value,
        financial_year: financialYear?.value,
        month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
          getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
        }`,
        gst_form_type: "GSTR1",
        token,
      };
      dispatchApproveGst(finalData);
    }
  };

  const resetData = () => {
    setFinancialYear({ value: "", label: "" });
    setMonth({ value: "", label: "" });
    setBranchSelected({ value: "", label: "Select Branch" });
    dispatchResetGstrOne();
    setGstNo({ value: "", label: "Select GST No." });
  };

  const toggleModal = () => {
    setShowhsnCount(!showhsnCount);
  };

  const handleFilingGstToggle = () => {
    // setFillGstToggle(!fillGstToggle);
    history.push({
      pathname: `/gst/gstr-one/${client_code}/filing`,
      state: {
        gstin: gstNo,
        clientCode: client_code,
        financialYear: financialYear,
        month: month,
        client_code,
        company_name,
        isNil: gstrOneData?.gstr1_13_data?.total_count === 0 ? true : false,
        gstNo,
        status: gstOneFilingStatus,
      },
    });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
            }}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetGstModuleError();
              dispatchResetSuccess();
            }}
          />
        );
      }
    }
    if (gstOneFilingStatusSuccess === 0) {
      if (gstOneFilingStatusStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!gstOneFilingStatusError}
            title="Error"
            message={gstOneFilingStatusError}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
            }}
            statusCode={gstOneFilingStatusStatusCode}
          />
        );
      } else if (
        gstOneFilingStatusError &&
        gstOneFilingStatusStatusCode !== 401
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!gstOneFilingStatusError}
            title="Error"
            message={gstOneFilingStatusError}
            buttonText="OK"
            onPress={() => {
              dispatchResetGstOneFilingStatusSuccess();
              dispatchResetGstOneFilingStatusError();
              dispatchResetGstOneFilingStatusStatusCode();
              dispatchResetGstOneFilingStatusMessage();
            }}
          />
        );
      }
    }

    if (gstCommentSuccess === 1) {
      dispatchResetCommentsSuccess();
      toast.success("Comment Added Successfully!", {
        duration: 2000,
      });
      let monthData = month?.value?.split("-")?.[0];
      if (financialYear) {
        const finalData = {
          client_code: client_code,
          gstin: gstNo?.value,
          financial_year: financialYear?.value,
          month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
            getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
          }`,
          gst_form_type: "GSTR1",
          token,
        };
        dispatchGetAllGstCommentsAction(finalData);
      }
    }
    return false;
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  // const handleIsNill = () => {
  //   setIsNil(!isNil);
  // };

  const handleSubmitGstComment = (data: string) => {
    let monthData = month?.value?.split("-")?.[0];
    if (token) {
      let finalData = {
        client_code,
        token,
        comment: data,
        gstin: gstNo?.value,
        financial_year: financialYear?.value,
        month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
          getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
        }`,
        gst_form_type: "GSTR1",
      };
      dispatchPostGstCommentsAction(finalData);
    }
  };

  let commentArray =
    gstCommentData?.comments_details?.length > 0
      ? [...gstCommentData.comments_details].reverse()
      : [];

  const handleAddARN = (arnNumber: string) => {
    let monthData = month?.value?.split("-")?.[0];
    let yearData = 20 + month?.value?.split("-")?.[1];
    let finalData = {
      token,
      client_code,
      gstin: gstNo?.value,
      year: yearData,
      month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
        getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
      }`,
      acknowledgement_number: arnNumber,
      gstr_type: "gstr_1",
    };
    if (token && client_code) {
      dispatchPostARNNumberAction(finalData);
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonHeader title="GSTR-1" />
        </div>
        <RenderHeaderCard>
          <div className="col-md-12 gst">
            <div className="header">
              Form GSTR-1 <span className="sub-heading">[See rule 59(1)]</span>
            </div>
          </div>
          <div className=" col-md-12">
            <div className="mt-2 asset_details_text_all_user">
              {" "}
              <span>
                <img src={WarningIcon} alt="warning" />
              </span>{" "}
              For GSTR-1 Filing, please ensure Authorized Signatory Details are
              filled in Business Address and Authorized Signatory PAN Number is
              verified.
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <div className="details">
              DETAILS OF OUTWARD SUPPLIES OF GOOD OR SERVICES
            </div>
          </div>

          <div
            className="col-md-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "7px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-start",
              }}
            >
              <div style={{ width: "250px" }}>
                <label htmlFor="">GST No.</label>
                <Select
                  options={gstNoList}
                  placeholder="Select GST No"
                  value={gstNo}
                  components={{ Option }}
                  onChange={(e: any) => handleChangeInput(e, "gstno")}
                />
              </div>
              <div className="d-flex align-items-center">
                <div className="mt-4">OR</div>
              </div>
              <div style={{ width: "175px" }}>
                <label htmlFor="">Branch</label>
                <Select
                  placeholder="Select Branch"
                  options={branchList}
                  value={branchSelected}
                  cacheOptions
                  onChange={(e: any) => handleChangeInput(e, "branch")}
                />
              </div>

              <div style={{ width: "175px" }}>
                <label htmlFor="">Financial Year</label>
                <Select
                  options={finacialYearOptions?.reverse()}
                  value={
                    !!financialYear.value
                      ? financialYear
                      : finacialYearOptions[finacialYearOptions?.length - 1]
                  }
                  onChange={(e: any) => handleChangeInput(e, "fy")}
                />
              </div>

              <div style={{ width: "175px" }}>
                <label htmlFor="">Month</label>
                <Select
                  options={getMonthsOptions}
                  value={
                    !!month.value
                      ? month
                      : {
                          value: `Apr-${financialStartYear}`,
                          label: `Apr-${financialStartYear}`,
                        }
                  }
                  onChange={(e: any) => handleChangeInput(e, "month")}
                />
              </div>

              {isGstFillingPresent ? (
                <div className="d-flex justify-content-center align-items-center ">
                  <button
                    className="btn btn-primary mt-4 ml-4"
                    onClick={() => {
                      setFillGstToggle(true);
                    }}
                    disabled={
                      !gstNo?.value ||
                      gstfiledData?.ackNumber ||
                      gstNo?.authorizedSignatoryPanDeatils?.status != "VALID"
                    }
                  >
                    File GSTR-1
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* commented for future use  */}
            {/* <div>
                        <ButtonDropdown
                            isOpen={toggle}
                            toggle={() => {
                                setToggle(!toggle)
                            }}
                        >
                            <DropdownToggle
                                caret
                                color="secondary"
                                style={{ backgroundColor: "white", color: "red", border: "1px solid red" }}
                                outline
                            >
                                <span className='mr-2'>
                                    <img src={NewDownloadIconActive} alt="Download" />
                                </span>

                                Export
                            </DropdownToggle>

                            <DropdownMenu style={{ width: "100%", minWidth: "7px" }}>

                            </DropdownMenu>
                        </ButtonDropdown>
                    </div> */}
          </div>
          <div
            className="col-md-12 mt-2"
            style={{ color: "#7c8db0", fontWeight: 500 }}
          >
            Note: You can select either the GST number or the branch, but not
            both.
          </div>
          <div className="mt-2">
            <GstrOneAutoFilledTable
              data={{
                ...(branchSelected?.value ? branchSelected : gstNo),
                ...gstfiledData,
              }}
              gst={gstNo?.value ? true : false}
              handleAddARN={handleAddARN}
              selecteMonth={month?.value}
              // clientCode={client_code}
            />
          </div>

          <GstrOneTable
            handleGstrOneInvoiceList={handleGstrOneInvoiceList}
            gstrOneInvoiceData={gstrOneInvoiceData}
            invoiceSourceKey={invoiceSourceKey}
            nestedSourceKey={nestedSourceKey}
            gstr1Data={gstr1Data}
            setGstr1Data={setGstr1Data}
            gstrOneData={gstrOneData}
            showhsnCount={showhsnCount}
            setShowhsnCount={setShowhsnCount}
          />
        </RenderHeaderCard>
      </div>
      <Modal
        size="xl"
        isOpen={showhsnCount}
        toggle={() => setShowhsnCount(true)}
      >
        <ModalHeader className="pt-4 pl-4" toggle={toggleModal}>
          HSN Wise Summary
        </ModalHeader>
        <ModalBody className="p-0">
          {getGstrOnehsnWiseList?.length ? (
            <div className="jobsType">
              <table className="table thead-light table-bordered">
                <thead className="text-start sticky-table-header">
                  {getGstrOnehsnWiseList?.length > 0 && (
                    <TableHeader tableHeader={HSN_SUMMARY_HEADERS} />
                  )}
                </thead>

                <tbody>
                  {getGstrOnehsnWiseList &&
                    getGstrOnehsnWiseList?.length > 0 &&
                    getGstrOnehsnWiseList?.map((itemData: any) => {
                      return (
                        <tr>
                          {HSN_SUMMARY_HEADERS?.map(
                            (item: TableHeadersType) => {
                              return (
                                <td>
                                  {typeof itemData[item?.value] === "number"
                                    ? changeToDecimel(itemData[item?.value])
                                    : itemData[item?.value]}
                                </td>
                              );
                            }
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          ) : (
            <div
              style={{
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "30px",
              }}
            >
              No Data Found !
            </div>
          )}
        </ModalBody>
      </Modal>
      {(isApprovalPresent || isCommentPresent) && gstNo?.value ? (
        <Approve
          handleApproval={handleApproval}
          isApprove={isApprovalPresent}
          approved={approved}
          isAddComments={isCommentPresent}
          handleToggleCommentsModal={handleToggleGstCommentsModal}
          approvalDetails={gstrOneData?.approval_details?.approval_details}
          approveBtnText={"Approve GSTR-1 Form"}
        />
      ) : (
        ""
      )}
      {fillGstToggle && (
        <CommfirmationWithActionModal
          toggle={handleShowConfirmationModal}
          isOpen={fillGstToggle}
          message={`Filing GSTR-1 for the ${month?.label} Period of the GST Number: ${gstNo?.value} ?`}
          confirmButtonText={"Confirm"}
          onPressConfirm={() => {
            handleShowConfirmationModal();
            handleFilingGstToggle();
          }}
          actionShow={false}
          actionMessage={
            gstrOneData?.gstr1_13_data?.total_count === 0 ? (
              <>
                No invoices found in this GSTR-1 form. You are about to file a{" "}
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Nil Return
                </span>{" "}
                for this period. Do you want to proceed?
              </>
            ) : null
          }
        />
      )}
      {showGstCommentsModal && (
        <CommentModal
          modal={showGstCommentsModal}
          toggleModal={handleToggleGstCommentsModal}
          data={commentData}
          commentList={commentArray}
          handlePostComment={handleSubmitGstComment}
          commentLabel="Comment"
        />
      )}
      <Toaster />

      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
  branch: state.clientSettings.businessAddressList,
  gstrOneData: state.gst.gstrOneData,
  gstrOneInvoiceList: state.gst.gstrOneInvoiceList,
  getGstrOnehsnWiseList: state.gst.getGstrOnehsnWiseList,
  error: state.gst.error,
  success: state.gst.success,
  message: state.gst.message,
  statusCode: state.gst.statusCode,
  gstNumberList: state.gst.gstNumberList,
  loginData: state.auth.loginData,
  gstCommentData: state.gst.gstCommentData,
  gstCommentSuccess: state.gst.gstCommentSuccess,
  gstOneFilingStatusError: state.gst.gstOneFilingStatusError,
  gstOneFilingStatusSuccess: state.gst.gstOneFilingStatusSuccess,
  gstOneFilingStatusMessage: state.gst.gstOneFilingStatusMessage,
  gstOneFilingStatusStatusCode: state.gst.gstOneFilingStatusStatusCode,
  gstOneFilingStatus: state.gst.gstOneFilingStatus,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetFetching: () => dispatch(resetFetching()),
  dispatchResetSuccess: () => dispatch(resetGstModuleSuccess()),
  dispatchResetMessage: () => dispatch(resetGstMessage()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchGetGstrOneAction: (data: GstrOnePayload) =>
    dispatch(getGstrOneListAction(data)),
  dispatchGetGstrOneInvoiceListAction: (data: GstrOnePayload) =>
    dispatch(getGstrOneInvoiceListAction(data)),
  dispatchResetGstrOne: () => dispatch(resetGstrOneData()),
  dispatchResetGstModuleError: () => dispatch(resetGstModuleError()),
  dispatchResetGstInvoiceListAction: () => dispatch(resetGstrInvoiceList()),
  dispatchGetGstrOnehsnWiseCountAction: (data: GstrOnehsnWiseCountPayload) =>
    dispatch(getGstrOnehsnWiseCountAction(data)),
  dispatchResetGetGstrOnehsnWiseCount: () =>
    dispatch(resetGstrOnehsnWiseList()),
  dispatchResetGstFillingError: () => dispatch(resetGstFilingError()),
  dispatchResetGstFillingSuccess: () => dispatch(resetGstFilingSuccess()),
  dispatchGetGstNumber: (data: GetGstNumberPayload) =>
    dispatch(getGstNumberList(data)),
  dispatchResetGetGstNumber: () => dispatch(resetGstNumberList()),
  dispatchApproveGst: (data: ApproveGstPayloadType) =>
    dispatch(approveGstAction(data)),
  dispatchPostGstCommentsAction: (data: GstCommentPayloadType) =>
    dispatch(gstPostCommentAction(data)),
  dispatchResetCommentsSuccess: () => dispatch(resetGstCommentsSuccess()),
  dispatchGetAllGstCommentsAction: (data: GstGetAllCommentPayloadType) =>
    dispatch(gstGetAllCommentAction(data)),
  dispatchGstOneFilingStatus: (data: GstrOneSatusType) =>
    dispatch(gstOneFilingStatus(data)),
  dispatchResetGstOneFilingStatus: () => dispatch(resetGstOneFilingStatus()),
  dispatchResetGstOneFilingStatusSuccess: () =>
    dispatch(resetGstOneFilingStatusSuccess()),
  dispatchResetGstOneFilingStatusError: () =>
    dispatch(resetGstOneFilingStatusError()),
  dispatchResetGstOneFilingStatusStatusCode: () =>
    dispatch(resetGstOneFilingStatusStatusCode()),
  dispatchResetGstOneFilingStatusMessage: () =>
    dispatch(resetGstOneFilingStatusMessage()),
  dispatchPostARNNumberAction: (data: ARNNumberPayloadType) =>
    dispatch(postARNNumberAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GstrOne);
